import { useAiImageStoreShallow } from "../store";

export const AiImagePromptAreaTextarea = () => {
  const { prompt, setPrompt, type } = useAiImageStoreShallow((s) => ({
    prompt: s.prompt,
    setPrompt: s.setPrompt,
    type: s.type,
  }));
  return (
    <textarea
      value={prompt}
      onChange={(e) => setPrompt(e.target.value)}
      className="tw-w-full tw-h-20 tw-pl-11 no-scrollbar tw-resize-none tw-border-none tw-outline-none tw-bg-transparent tw-align-top tw-placeholder:tw-align-top"
      placeholder={`Describe your ${type}...`}
    />
  );
};
